module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/cloudy-f6e6108ec3b4605bda2aca61f011e8e8.svg";